export default "__VITE_ASSET__CJih2OaR__"